import Vue from 'vue'

import Clock from './components/Clock'

const Components = {
  Clock
}

Object
  .keys(Components)
  .forEach(name => { Vue.component(name, Components[name]) })

export default Components
